/** @format */

import React, { FunctionComponent } from 'react';
import { Chip } from '@material-ui/core';
import i18n from '../../core/i18n';
import { ReactComponent as Cancel } from '../../assets/themes/OPL/img/icons/Cancel.svg';
import { FilterReducerFieldName } from '../../modules/filter/FilterReducers';
import { useDispatch } from 'react-redux';

const _ = require('underscore');

type FilterListItemProps = {
    item: any;
    value: any;
};

const retrieveDateConditionalIfApplicable = (fieldName: string, item: any): string => {
    //Todo?: Should we propagate TableHeaderContentCell type instead of this?
    if (!Date.parse(item)) {
        return '';
    }

    if (fieldName.includes('[before]')) {
        return ' ' + i18n.t('general:common.to').toLowerCase();
    }

    if (fieldName.includes('[after]')) {
        return ' ' + i18n.t('general:common.from').toLowerCase();
    }

    return '';
};

const checkForBooleanValues = (value: string): string => {
    if (value === 'true') {
        return i18n.t('general:common.yes');
    }

    if (value === 'false') {
        return i18n.t('general:common.no');
    }

    return i18n.t(value);
};

const checkIfKeyExists = (value: string): boolean => {
    return i18n.exists(value);
};

export const FilterListItem = (props: FilterListItemProps): React.ReactElement => {
    const { item, value } = props;
    const dispatch = useDispatch();
    const rawValue = item.rawValue;
    return (
        <div style={{ display: 'inline-block', width: 'fit-content', padding: '2px' }}>
            <Chip
                size={'small'}
                label={
                    <div style={{ marginTop: 5 }}>
                        <span>{i18n.t(item.columnName) + retrieveDateConditionalIfApplicable(item.elementName, value)}: </span>
                        {checkIfKeyExists(value) && <span style={{ fontWeight: 'bold' }}>{i18n.t(value)}</span>}
                        {!checkIfKeyExists(value) && (
                            <span style={{ fontWeight: 'bold' }}>{Date.parse(value) ? value : checkForBooleanValues(value)}</span>
                        )}
                    </div>
                }
                // deleteIcon={<Cancel style={{ width: 16, height: 16 }} />}
                // onDelete={(): void => {
                //     let newRawValue: any = [];
                //
                //     if (Array.isArray(item.value)) {
                //         item.value.map((el: any, index: number) => {
                //             if (el !== value) {
                //                 newRawValue.push(item.rawValue[index]);
                //             }
                //         });
                //
                //         item.rawValue = newRawValue;
                //     }
                //
                //     dispatch({
                //         type: FilterReducerFieldName.HEADER_FILTER_MANAGE_ELEMENT,
                //         item: item,
                //         value: value,
                //         rawValue: item.rawValue ?? [],
                //         removeFilterElement: true,
                //     });
                // }}
            />
        </div>
    );
};
